import { BaseEntity } from "yt-ng-framework";

export class KomitentTelefon extends BaseEntity{
    constructor(){
        super();
    }

    KomitentID: number = null;
    Glavni:boolean = null;
    VrstaTelefonaID:number = null;
    Broj:string = null;
    Lokal:string = null;
    SvojinaID:number = null;
    Opis:string = null;

    Deserialize(input:any){
        // super.Deserialize(input);
        this.ID=input.ID;
        this.KomitentID=input.KomitentID;
        this.Glavni=input.Glavni;
        this.VrstaTelefonaID=input.VrstaTelefonaID;
        this.Broj=input.Broj;
        this.Lokal=input.Lokal;
        this.SvojinaID=input.SvojinaID;
        this.Opis=input.Opis;
        return this;
    }

    Serialize(input:KomitentTelefon){
        return input;
    }
}